import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BoardsService } from 'src/app/service/boards.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ReplaySubject, map, startWith } from 'rxjs';

@Component({
  selector: 'app-monthly-task',
  templateUrl: './monthly-task.component.html',
  styleUrls: ['./monthly-task.component.scss'],
  standalone: false ,  // NOSONAR
})
export class MonthlyTaskComponent implements OnInit {


  selectedRegions: { label: string; value: string }[] = [];

  userdropdownTemp: any = [];
  userdropdown: any = [];
  temp2: string;
  userData;
  selected_puser;
  selected_suser;
  selected_region;
  selected_period;
  selected_board;
  selected_dday;

  temp4;
  temp5;

  temp: string;
  temp3: string;
  regionList: any;
  selectedRegionsTemp: any = [];
  taskData;
  selectedTask;

  options;
  selected_duetime;

  periodData;
  boardData;


  successMessage = '';
  errorMessage = '';

  selected_startmonth;
  selected_region_Temp_final: any = [];
  selected_monthtype = 'D';
  dayofMonth = 1;
  selected_recureveryweek = 1;
  selected_occurance = 1;
  dayofWeek = 1;
  minMonth;
  maxMonth;

  selected_pattern = 1;
  maxDateOfMonth = 30;


  userID;
  usertemp: string;
  userInfo: any;
  s_region_flag: boolean = true;
  selected_reg;
  selected_pValue: any;
  selected_sValue: any;
  taskDataDrpDwn: any[];
  filteredUserDropdown: any;
  filteredTaskDataDrpDwn: any[];
  taskFilter: FormControl = new FormControl('');
  filteredTasks: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  puserFilter: FormControl = new FormControl('');
  filteredPusers: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  suserFilter: FormControl = new FormControl('');
  filteredSusers: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  regionFilterCtrl: FormControl = new FormControl();
  filteredRegions: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  constructor(private  readonly ngxUiLoaderService: NgxUiLoaderService, private readonly boardService: BoardsService,
    private readonly router: Router) {


    this.ngxUiLoaderService.start("loader-01");

    //fetch from local-storage
    this.temp = localStorage.getItem('task-data');
    this.taskData = JSON.parse(this.temp);

    const temp = [];
    let obj;

    this.taskData.forEach(element => {

      obj = { "label": element.description, "value": element.taskID };
      temp.push(obj);

    });

    this.taskDataDrpDwn = temp;
    this.filteredTaskDataDrpDwn = [...this.taskDataDrpDwn];

    //fetch from local-storage
    this.temp3 = localStorage.getItem('region-data');
    this.regionList = JSON.parse(this.temp3);

    this.regionList?.forEach(element => {
      

     const obj = { "label": element.region, "value": element.region_code };
      this.selectedRegionsTemp.push(obj);
    });

    this.selectedRegions = this.selectedRegionsTemp;


    //fetch from local-storage
    this.temp2 = localStorage.getItem('users-data');
    this.userData = JSON.parse(this.temp2);


    this.userData?.forEach(element => {
    

     const obj = { "label": element.firstName + ' ' + element.lastName, "value": element.userPrincipalName };
      this.userdropdownTemp.push(obj);
    });

    this.userdropdown = this.userdropdownTemp;
    this.filteredUserDropdown = [...this.userdropdown];

    //fetch from local-storage
    this.temp4 = localStorage.getItem('period-data');
    this.periodData = JSON.parse(this.temp4);

    this.temp5 = localStorage.getItem('board-data');
    this.boardData = JSON.parse(this.temp5);



    this.options = ["00:00", "00:05", "00:10", "00:15", "00:20", "00:25", "00:30",
      "00:35", "00:40", "00:45", "00:50", "00:55", "01:00", "01:05", "01:10",
      "01:15", "01:20", "01:25", "01:30", "01:35", "01:40", "01:45", "01:50",
      "01:55", "02:00", "02:05", "02:10", "02:15", "02:20", "02:25", "02:30",
      "02:35", "02:40", "02:45", "02:50", "02:55", "03:00", "03:05", "03:10",
      "03:15", "03:20", "03:25", "03:30", "03:35", "03:40", "03:45", "03:50",
      "03:55", "04:00", "04:05", "04:10", "04:15", "04:20", "04:25", "04:30",
      "04:35", "04:40", "04:45", "04:50", "04:55", "05:00", "05:05", "05:10",
      "05:15", "05:20", "05:25", "05:30", "05:35", "05:40", "05:45", "05:50",
      "05:55", "06:00", "06:05", "06:10", "06:15", "06:20", "06:25", "06:30",
      "06:35", "06:40", "06:45", "06:50", "06:55", "07:00", "07:05", "07:10",
      "07:15", "07:20", "07:25", "07:30", "07:35", "07:40", "07:45", "07:50",
      "07:55", "08:00", "08:05", "08:10", "08:15", "08:20", "08:25", "08:30",
      "08:35", "08:40", "08:45", "08:50", "08:55", "09:00", "09:05", "09:10",
      "09:15", "09:20", "09:25", "09:30", "09:35", "09:40", "09:45", "09:50",
      "09:55", "10:00", "10:05", "10:10", "10:15", "10:20", "10:25", "10:30",
      "10:35", "10:40", "10:45", "10:50", "10:55", "11:00", "11:05", "11:10",
      "11:15", "11:20", "11:25", "11:30", "11:35", "11:40", "11:45", "11:50",
      "11:55", "12:00", "12:05", "12:10", "12:15", "12:20", "12:25", "12:30",
      "12:35", "12:40", "12:45", "12:50", "12:55", "13:00", "13:05", "13:10",
      "13:15", "13:20", "13:25", "13:30", "13:35", "13:40", "13:45", "13:50",
      "13:55", "14:00", "14:05", "14:10", "14:15", "14:20", "14:25", "14:30",
      "14:35", "14:40", "14:45", "14:50", "14:55", "15:00", "15:05", "15:10",
      "15:15", "15:20", "15:25", "15:30", "15:35", "15:40", "15:45", "15:50",
      "15:55", "16:00", "16:05", "16:10", "16:15", "16:20", "16:25", "16:30",
      "16:35", "16:40", "16:45", "16:50", "16:55", "17:00", "17:05", "17:10",
      "17:15", "17:20", "17:25", "17:30", "17:35", "17:40", "17:45", "17:50",
      "17:55", "18:00", "18:05", "18:10", "18:15", "18:20", "18:25", "18:30",
      "18:35", "18:40", "18:45", "18:50", "18:55", "19:00", "19:05", "19:10",
      "19:15", "19:20", "19:25", "19:30", "19:35", "19:40", "19:45", "19:50",
      "19:55", "20:00", "20:05", "20:10", "20:15", "20:20", "20:25", "20:30",
      "20:35", "20:40", "20:45", "20:50", "20:55", "21:00", "21:05", "21:10",
      "21:15", "21:20", "21:25", "21:30", "21:35", "21:40", "21:45", "21:50",
      "21:55", "22:00", "22:05", "22:10", "22:15", "22:20", "22:25", "22:30",
      "22:35", "22:40", "22:45", "22:50", "22:55", "23:00", "23:05", "23:10",
      "23:15", "23:20", "23:25", "23:30", "23:35", "23:40", "23:45", "23:50",
      "23:55"];

    // 2021-11
    this.minMonth = new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1).toString();
    this.maxMonth = (new Date().getFullYear() + 1).toString() + '-' + (new Date().getMonth()).toString();

    console.info("start month min", this.minMonth, "start month max", this.maxMonth);

    // setting month default
    this.selected_startmonth = this.minMonth;

    this.ngxUiLoaderService.stop("loader-01");
  }

  ngOnInit(): void {  
    this.taskFilter.valueChanges.pipe(
      startWith(''), map(search => {
        if (search) {
          return this.filtertasks(search);
        }

        if (this.taskDataDrpDwn) {
          return this.taskDataDrpDwn.slice();
        }

        return [];
      }))
      .subscribe(filtered => {
        this.filteredTasks.next(filtered);
      });
    this.puserFilter.valueChanges.pipe(
      startWith(''), map(search => {
        if (search) {
          return this.filterPuser(search);
        }

        if (this.userdropdown) {
          return this.userdropdown.slice();
        }

        return [];
      }))
      .subscribe(filtered => {
        this.filteredPusers.next(filtered);
      });
    this.suserFilter.valueChanges.pipe(
      startWith(''), map(search => {
        if (search) {
          return this.filterSuser(search);
        }

        if (this.userdropdown) {
          return this.userdropdown.slice();
        }

        return [];
      }))
      .subscribe(filtered => {
        this.filteredSusers.next(filtered);
      });
    this.regionFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search =>
          {
          if (search) {
            return this.filterRegions(search);
          }

          if (this.selectedRegions) {
            return this.selectedRegions.slice();
          }

          return [];
        }
        )
      )
      .subscribe(filtered => {
        this.filteredRegions.next(filtered);
      });
  }
  filtertasks(search: string): any[] {
    if (!search) {
      return this.taskDataDrpDwn.slice();
    }

    return this.taskDataDrpDwn.filter(user =>
      user.label.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterPuser(search: string): any[] {
    if (!search) {
      return this.userdropdown.slice();
    }

    return this.userdropdown.filter(user =>
      user.label.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterSuser(search: string): any[] {
    if (!search) {
      return this.userdropdown.slice();
    }

    return this.userdropdown.filter(user =>
      user.label.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterRegions(search: string): { label: string; value: string }[] {
    // return filtered array
    return this.selectedRegions.filter(region =>
      region.label.toLowerCase().includes(search.toLowerCase())
    );

  }
  isAllSelected(): boolean {
    return this.selected_region?.length == this.selectedRegions.length; // NOSONAR
  }

  isIndeterminate(): boolean {
    return this.selected_region?.length > 0 && !this.isAllSelected();
  }
  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.selected_region = [...this.selectedRegions];
    } else {
      this.selected_region = [];
    }
  }


  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  onStartMonthSet() {

    //reset day of month
    this.dayofMonth = undefined;

    const month = this.selected_startmonth.split('-')[1];
    const yr = this.selected_startmonth.split('-')[0];


    this.maxDateOfMonth = this.daysInMonth(month, yr);


  }


  addtask() {




    console.info("board", this.selected_board, "task", this.selectedTask,
      "start month", this.selected_startmonth,
      "month type", this.selected_monthtype,
      "day of month", this.dayofMonth,
      "recur evry week", this.selected_recureveryweek,
      "occurance", this.selected_occurance,
      "pattern", this.selected_pattern,
      "duetime", this.selected_duetime, "day of week", this.dayofWeek, "puser",
      this.selected_puser, "suser", this.selected_suser, "region", this.selected_region);

    if (this.selected_board == undefined || this.selectedTask == undefined) { // NOSONAR
      this.errorMessage = "Please fill in the required fields!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else if ((!this.selected_puser && !this.selected_region) || (!this.selected_puser && this.selected_region == '')) { // NOSONAR
      this.errorMessage = "At least a Primary user or a region must be selected.";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else {

      if (this.selected_puser) {
        this.selected_pValue = this.selected_puser.value;
      }


      if (this.selected_suser) {
        this.selected_sValue = this.selected_suser.value;
      }

      if (this.selected_region) {
        this.selected_region.forEach(element => {

          this.selected_region_Temp_final.push(element.value);
        });

        this.selected_reg = this.selected_region_Temp_final.toString();
      }

      this.addtask_sub()



     

    }

  }

  addtask_sub()
  {
     const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      }




      const dateObj = new Date();
      const month = dateObj.getUTCMonth() + 1; //months from 1-12
      const day = dateObj.getUTCDate();
      const year = dateObj.getUTCFullYear();

      let due_time;

      if (!this.selected_duetime) {
        due_time = '23:59';
      } else {
        due_time = this.selected_duetime;
      }

      const due = month + "-" + day + "-" + year + ' ' + due_time;



      // not undefined
      if (!this.selected_puser) {
        this.selected_puser = null;
      }
      if (!this.selected_suser) {
        this.selected_suser = null;
      }
      if (this.selected_region == '') { // NOSONAR
        this.selected_region = null;
      }


      let dataArr;
      if (this.selected_monthtype == "D" || this.selected_monthtype == undefined) { // NOSONAR


        dataArr = {
          "lastupdatedBy": this.userID,
          "boardId": this.selected_board,
          "taskId": this.selectedTask.value,
          "startMonth": this.selected_startmonth,
          "monthType": this.selected_monthtype,
          "day": this.dayofMonth,
          "recurWeeks": this.selected_recureveryweek,
          "occurance": this.selected_occurance,
          "dueTime": due,
          // "daysOfWeek": this.dayofWeek,
          "primaryUser": this.selected_pValue,
          "secondaryUser": this.selected_sValue,
          "region": this.selected_reg
        }
      }

      else if (this.selected_monthtype == "W") { // NOSONAR


        dataArr = {
          "lastupdatedBy": this.userID,
          "boardId": this.selected_board,
          "taskId": this.selectedTask.value,
          "startMonth": this.selected_startmonth,
          "monthType": this.selected_monthtype,
          "monthPattern": this.selected_pattern,
          // "day": this.dayofWeek,
          "recurWeeks": this.selected_recureveryweek,
          "occurance": this.selected_occurance,
          "dueTime": due,
          "daysOfWeek": this.dayofWeek,
          "primaryUser": this.selected_pValue,
          "secondaryUser": this.selected_sValue,
          "region": this.selected_reg
        }
      }




      this.ngxUiLoaderService.start("loader-01");

      this.boardService.addMonthlyTask(dataArr).subscribe(result => {
        if (!result) {
          this.errorMessage = 'Task already exists!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
          this.ngxUiLoaderService.stop("loader-01");
        }

        else if (result) {
          this.router.navigate(['./board']);
        }
      });



      // reset values
      this.selected_region_Temp_final = [];
      this.s_region_flag = true;
  }

  flagFunc() {
    if (this.selected_region.length == 0) { // NOSONAR
      this.s_region_flag = true;
    }
    else if (this.selected_region.length > 0) {
      this.s_region_flag = false;
    }
    else if (this.selected_region == undefined) { // NOSONAR
      this.s_region_flag = true;
    }
  }

}
